import { useState } from "react";
import { useNavigate } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import Button from "../../components/Button";
import LieuFormFields from "./LieuFormFields";
import { useCreateLieu } from "../../../hooks/useCreateLieu";
import type { LieuDto } from "../../../api/lieuxApi";

const INITIAL: LieuDto = {
  name: "",
  description: "",
  addressName: "",
  address: {},
  artistIds: [],
};

export default function LieuCreatePage() {
  const navigate = useNavigate();
  const [draft, setDraft] = useState<LieuDto>(INITIAL);
  const create = useCreateLieu();

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    create.mutate(draft, { onSuccess: (res) => navigate(`/admin/lieux/${res.id}`) });
  };

  return (
    <form onSubmit={onSubmit}>
      <PageHeader
        title="Nouveau lieu"
        description="Ajout d'un lieu au catalogue du tenant."
        actions={
          <>
            <Button type="button" variant="ghost" onClick={() => navigate("/admin/lieux")}>
              Annuler
            </Button>
            <Button type="submit" variant="primary" loading={create.isPending}>
              Créer
            </Button>
          </>
        }
      />
      <div className="bo-card">
        <LieuFormFields value={draft} onChange={setDraft} />
      </div>
      {create.isError && <p className="bo-error-text">Erreur : {(create.error as Error)?.message}</p>}
    </form>
  );
}
